<template>
    <div class="summary-payment">
        <!-- Reseller-POS: Kassierer handelt im Auftrag, kein Endkunden-AGB-Flow. -->
        <summary-agb v-if="!orderNumber && !loginusername" :settings="settings" ref="agb"/>

        <div class="uk-margin-medium-top uk-flex uk-flex-right">
            <div>
                <button v-if="!orderNumber"
                        class="uk-button uk-button-default uk-margin-small-right"
                        @click="back">
                    {{ $t("Zurück") }}
                </button>
            </div>
            <div>
                <!-- Reseller: tender-spezifischer Button -->
                <button v-if="!orderNumber && loginusername"
                        @click="submitReseller"
                        class="uk-button uk-button-primary submitbtn"
                        type="button"
                >
                    <span class="uk-margin-small-right">{{ resellerButtonIcon }}</span>{{ $t(resellerButtonLabel) }}
                </button>
                <button v-else-if="!orderNumber && (store.state.paymentType == 'bank' || store.state.paymentType == 'directsale' || store.state.total == 0)"
                        @click="submit"
                        class="uk-button uk-button-primary submitbtn"
                        type="button"
                >{{ $t(buyButtonLabel) }}</button>
                <button v-else-if="store.state.paymentType === 'mollie' && store.state.total > 0"
                        class="uk-button uk-button-primary submitbtn"
                        type="button"
                        @click="submitMollie"
                >{{ $t(buyButtonLabel) }}</button>
                <p v-if="mollieRedirect && inIframe()">
                    {{ $t("CheckPopup") }}
                </p>
            </div>
        </div>
    </div>

</template>

<script>
import SummaryAgb from "./SummaryAgb";
import helper from "../../helper/helper";

export default {
    mixins: [helper],
    props: ['settings', 'loginusername'],
    components: {SummaryAgb},
    data: () => {
        return {
            orderNumber: '',
            serverErrorWording: '',
            mollieRedirect: '',
        }
    },
    computed: {
        // A 0 € cart is not "kostenpflichtig" — the button must not claim a payment obligation.
        buyButtonLabel() {
            return this.store.state.total <= 0 ? 'Jetzt kostenlos bestellen' : 'Jetzt kaufen';
        },
        resellerButtonLabel() {
            if (this.store.state.tender === 'card_terminal') return 'Mit Karte kassieren';
            if (this.store.state.tender === 'cash') return 'Bar kassieren';
            if (this.store.state.tender === 'cashless') return 'Cashless kassieren';
            return 'Kassieren';
        },
        resellerButtonIcon() {
            if (this.store.state.tender === 'card_terminal') return '💳';
            if (this.store.state.tender === 'cash') return '💶';
            if (this.store.state.tender === 'cashless') return '🪙';
            return '';
        },
    },
    mounted() {
        this.serverErrorWording = this.$t("Leider gab es Probleme bei der Verarbeitung der Bestellung. Bitte versuche es später nochmal.")
    },
    methods: {
        back() {
            this.$emit("back");
        },
        getOrderInformation() {
            const orderInfo = this.store.state.personData;
            orderInfo.payment_type = this.store.state.paymentType;
            if (this.store.state.couponType) {
                orderInfo.couponCode = this.store.state.couponCode;
                orderInfo.couponDiscount = this.store.state.couponDiscount;
            }
            if (this.store.state.donationSwitch && this.store.state.donationAmount) {
                orderInfo.donationAmount = parseInt(this.store.state.donationAmount ?? 0);
            }
            if (this.store.state.newsletterSignup) {
                orderInfo.newsletterSignup = this.store.state.newsletterSignup;
            }
            if (this.store.state.ownerData.token) {
                orderInfo.owner = this.store.state.ownerData.token
            }
            if (this.loginusername && this.store.state.tender) {
                orderInfo.tender = this.store.state.tender;
                if (this.store.state.tender === 'card_terminal' && this.store.state.terminalId) {
                    orderInfo.terminal_id = this.store.state.terminalId;
                }
            }
            const orders = Object.keys(this.store.state.selection).map(ticketId => {
                const ticket = this.store.state.selection[ticketId];
                const position = {
                    offer_id: ticketId,
                    amount: ticket.amount,
                    option: ticket.option
                };
                // Only send contacts for actually personalized offers; persons is
                // undefined for non-personalized / no_chip tickets and php-core's
                // OrderPositionsValid rejects a non-array contacts property.
                if (Array.isArray(ticket.persons) && ticket.persons.length) {
                    position.contacts = ticket.persons;
                }
                return position;
            });
            return { orderInfo, orders }
        },
        placeOrder() {
            this.store.state.loading = true;
            this.doOctoberRequest("onPlaceOrder", this.getOrderInformation()).then(response => {
                if (!response.error) {
                    this.orderNumber = response.order_number;
                    document.cookie = 'festiware::form='
                    if (typeof response.mollieRedirect !== 'undefined') {
                      this.mollieRedirect = response.mollieRedirect
                      this.openMollieWindow()
                    } else if (response.reseller) {
                      this.$emit('reseller-success', response)
                    } else {
                      window.location.href = response.redirect
                    }
                } else {
                    UIkit.notification(Object.values(response.error.error.response)[0])
                }
            }).catch(error => {
                // backendMessage() returns the reason the backend actually gave, or null
                // when it only sent a placeholder — then our own wording is the better
                // answer. Never statusText: "Internal Server Error" explains nothing.
                const message = this.backendMessage(error) || this.serverErrorWording;
                this.emitError('server', message, (error.responseText ?? '').includes("exceeds offer"));
            }).finally(() => {
                this.store.state.loading = false;
            })
        },
        openMollieWindow() {
            if (!this.inIframe()) {
                window.location.href = this.mollieRedirect;
            } else {
                try {
                    window.top.location.href = this.mollieRedirect;
                } catch (e) {
                    window.open(
                        this.mollieRedirect,
                        '_blank',
                        'noopener'
                    );
                }
            }
        },
        inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        submit() {
            if (this.$refs.agb.validate()){
                this.placeOrder()
            }
        },
        submitReseller() {
            // Reseller-POS: keine AGB-Validierung — der Kassierer handelt im Auftrag.
            // Tender + ggf. terminal_id sind in CheckoutPayment validiert worden.
            this.placeOrder();
        },
        submitMollie() {
            if (this.orderNumber) {
                this.openMollieWindow()
                return
            }
            if (this.$refs.agb.validate()){
                this.placeOrder()
            }
        }
    }
}
</script>

